import { PlusIcon } from '@phosphor-icons/react'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

import { BASE_CLIENT_DASHBOARD_QUERY_KEY } from '@/api/clients/get-clients-dashboard'
import NewClientForm from '@/components/Clients/NewClientForm'
import Dashboard from '@/components/Dashboard'
import { Page } from '@/components/layout/page'
import { PageHeader } from '@/components/layout/page-header'
import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'
import { ToggleSwitch } from '@/components/ui/toggle-switch'
import { PopupWithRequiredProps, popupFactory } from '@/factories'
import { useDesignVersionToggle } from '@/hooks'
import { UserRoleEnum } from '@/models/features/user.models'
import { selectUserRole } from '@/reducers/userDataReducer'
import { resetQueries } from '@/utils'

export const ClientsPage = () => {
  const { t } = useTranslation(['clients'])
  const userRole = useSelector(selectUserRole)

  const canAddResident = userRole !== UserRoleEnum.enum.ShiftManager

  const { redirect, toggle: handleUIToggle } = useDesignVersionToggle({
    group: 'clients',
    screen: 'Clients',
    to: { path: '/dashboard/clients/legacy' },
    version: 'new',
  })

  if (redirect) return redirect

  const handleOpenForm = () => {
    popupFactory.open(NewClientForm as FC<PopupWithRequiredProps>, {
      refreshClientsTable: () => {
        void resetQueries([BASE_CLIENT_DASHBOARD_QUERY_KEY])
      },
      showUserStatusPopup: () => {},
    })
  }

  // TODO: Remove Dashboard.Container from here. Padding and background color has to be provided to match rest of the pages.
  return (
    <Dashboard.Container className={`ctp-clients-page__wrapper`}>
      <Page>
        <PageHeader
          title={t('clients:list.title')}
          actions={
            <>
              <ToggleSwitch
                falsyLabel={t('clients:list.designToggle.old')}
                truthyLabel={t('clients:list.designToggle.new')}
                checked={true}
                onChange={handleUIToggle}
              />
              {canAddResident && (
                <Button size="small" onClick={handleOpenForm}>
                  {t('clients:list.actions.addResident')}
                  <Icon icon={PlusIcon} />
                </Button>
              )}
            </>
          }
        />
        <Outlet />
      </Page>
    </Dashboard.Container>
  )
}
